/**
 * FFA solo-human pause: only the visible world map may stamp ?mapView=1.
 * Hidden windows / unmount send mapView=0 so the bot can pause immediately.
 */

export function isWarEffortMapViewVisible() {
  return typeof document === 'undefined' || document.hidden !== true;
}

/**
 * @param {string} apiUrl
 * @param {number|string} missionId
 * @param {{ mapView?: boolean }} [options] mapView true stamps only when the document is visible
 * @returns {string}
 */
export function warEffortMissionStatusFetchUrl(apiUrl, missionId, { mapView } = {}) {
  if (apiUrl == null || apiUrl === '') {
    throw new Error('warEffortMissionStatusFetchUrl: apiUrl is required');
  }
  if (missionId == null) {
    throw new Error('warEffortMissionStatusFetchUrl: missionId is required');
  }
  const base = `${apiUrl}/war-effort/mission-status/${missionId}`;
  if (mapView !== true) return base;
  if (!isWarEffortMapViewVisible()) return base;
  return `${base}?mapView=1`;
}

/**
 * Drop the in-memory map stamp so the FFA bot can pause without waiting 60s.
 * @param {string} apiUrl
 * @param {number|string} missionId
 * @returns {Promise<Response>|null}
 */
export function clearWarEffortMapViewPresence(apiUrl, missionId) {
  if (apiUrl == null || apiUrl === '') {
    throw new Error('clearWarEffortMapViewPresence: apiUrl is required');
  }
  if (missionId == null) {
    throw new Error('clearWarEffortMapViewPresence: missionId is required');
  }
  const token = localStorage.getItem('token');
  if (!token) {
    throw new Error('clearWarEffortMapViewPresence: token is required');
  }
  return fetch(`${apiUrl}/war-effort/mission-status/${missionId}?mapView=0`, {
    headers: { Authorization: `Bearer ${token}` },
    keepalive: true
  });
}
